export default __webpack_public_path__ + "static/media/icon-filter-regular.50f7fda6.svg";